module.exports = __webpack_public_path__ + "img/example1.6e7b600c.png";